function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}

export { boxEquals, isDeltaZero };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/projection/geometry/utils.mjs
// module id = Chj9
// module chunks = 0